/**
 * @generated SignedSource<<4e6ece6d7ea53e1273ab8b3005b2479e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnifiedGamificationMutation$variables = {
  aaid: string;
  comment: string;
  value: number;
};
export type UnifiedGamificationMutation$data = {
  readonly unified: {
    readonly gamification: {
      readonly sendRecognition: {
        readonly errors: ReadonlyArray<{
          readonly code: string | null;
          readonly message: string | null;
        }> | null;
        readonly message: string | null;
        readonly success: boolean;
      } | null;
    } | null;
  } | null;
};
export type UnifiedGamificationMutation = {
  response: UnifiedGamificationMutation$data;
  variables: UnifiedGamificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aaid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "comment"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedMutation",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedGamificationMutation",
        "kind": "LinkedField",
        "name": "gamification",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "comment",
                "variableName": "comment"
              },
              {
                "kind": "Variable",
                "name": "receiverId",
                "variableName": "aaid"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "value"
              }
            ],
            "concreteType": "UnifiedGamificationPayload",
            "kind": "LinkedField",
            "name": "sendRecognition",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedMutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedGamificationMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnifiedGamificationMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3e4173051cfca047310d08c13126dc3f",
    "id": null,
    "metadata": {},
    "name": "UnifiedGamificationMutation",
    "operationKind": "mutation",
    "text": "mutation UnifiedGamificationMutation(\n  $aaid: String!\n  $comment: String!\n  $value: Int!\n) {\n  unified {\n    gamification {\n      sendRecognition(comment: $comment, value: $value, receiverId: $aaid) {\n        message\n        success\n        errors {\n          code\n          message\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c41338e0b2aca590dd28960902514351";

export default node;
